export default __webpack_public_path__ + "static/media/tem_no_parque1.ea410274.jpg";